<ng-template #renderCustomTitle>
  <ng-container *ngTemplateOutlet="customTitle"></ng-container>
</ng-template>
<ng-template #menuTrigger>
  <div class="menu" data-testId="app-menu-contents" [class.open]="isMenuOpen" [class.disabled]="disabled" [class.labeled]="label">
    <div class="flex-fill d-flex flex-column menu__contents">
      <!-- Make the title smaller on the top if the label is present -->
      <div class="menu__title flex-fill" *ngIf="title || customTitle !== null" [class.small]="label">
        <ng-container *ngIf="customTitle === null; else renderCustomTitle">
          {{ title }}
        </ng-container>
      </div>
      <div class="menu__label flex-fill" *ngIf="label">
        {{ label }}
      </div>
    </div>
    <div class="menu__icon">
      <span class="material-icons">{{ suffix }}</span>
    </div>
  </div>
</ng-template>
<div *ngIf="!disabled; else menuTrigger" class="menu__wrapping-trigger" [matMenuTriggerFor]="menu"
  (onMenuOpen)="onMenuOpen()" (onMenuClose)="onMenuClose()">
  <ng-container *ngTemplateOutlet="menuTrigger"></ng-container>
</div>
<mat-menu #menu="matMenu">
  <ng-content></ng-content>
</mat-menu>
